import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Icon from '@nubank/nuds-web/components/Icon/Icon';

import Image from '@nubank/www-latam-commons/components/Image/Image';

import FingerPrintIcon from './components/FingerPrintIcon';
import ShieldIcon from './components/ShieldIcon';
import { StyledContainer } from './style/Container';

const IconMap = {
  BellIcon: () => (Icon({ name: 'bell', ariaHidden: 'true' })),
  FingerPrintIcon,
  CardBlockedIcon: () => Icon({ name: 'card-blocked', ariaHidden: 'true' }),
  ShieldIcon: () => ShieldIcon({ 'aria-hidden': 'true' }),
};

function SectionSecurity({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  const securityItems = formatMessage({ id: `cms.accountPage.cardsArea[${index}].securityItems` });

  return (
    <Box tag="section">
      <Box>
        <Image
          altIntlKey="ACCOUNT.SECURITY.IMAGE_ALT"
          loading="lazy"
          srcSet={{
            xs: {
              '1x': 'roxinho-scene-card-with-phone/roxinho-scene-card-with-phone-xs@1x.jpg',
              '2x': 'roxinho-scene-card-with-phone/roxinho-scene-card-with-phone-xs@2x.jpg',
              '3x': 'roxinho-scene-card-with-phone/roxinho-scene-card-with-phone-xs@3x.jpg',
            },
            md: {
              '1x': 'roxinho-scene-card-with-phone/roxinho-scene-card-with-phone-md@1x.jpg',
              '2x': 'roxinho-scene-card-with-phone/roxinho-scene-card-with-phone-md@2x.jpg',
              '3x': 'roxinho-scene-card-with-phone/roxinho-scene-card-with-phone-md@3x.jpg',
            },
            lg: {
              '1x': 'roxinho-scene-card-with-phone/roxinho-scene-card-with-phone-lg@1x.jpg',
              '2x': 'roxinho-scene-card-with-phone/roxinho-scene-card-with-phone-lg@2x.jpg',
              '3x': 'roxinho-scene-card-with-phone/roxinho-scene-card-with-phone-lg@3x.jpg',
            },
          }}
        />
      </Box>
      <Box
        paddingBottom={{ xs: '20x', lg: '32x' }}
        paddingTop={{ xs: '8x', md: '12x', lg: '20x' }}
        paddingHorizontal={{ xs: '8x', md: '12x', lg: 56 }}
      >
        <Typography
          variant="title"
          intlKey={`cms.accountPage.cardsArea[${index}].title`}
          textAlign={{ md: 'center' }}
          marginBottom={{ md: '12x', lg: '16x' }}
          marginHorizontal={{ lg: 'auto' }}
        />
        <StyledContainer
          display={{ md: 'grid' }}
          gridTemplateColumns={{ md: 'repeat(6,1fr)', lg: 'repeat(12,1fr)' }}
          gridGap={{ md: '8x' }}
        >

          {securityItems && securityItems.map(item => {
            const IconComponent = IconMap[item.iconName];
            return (
              <Box
                gridColumn={{ md: 'span 3', lg: 'span 4' }}
                marginTop={{ xs: '8x', md: 0 }}
                key={item.id}
              >
                <IconComponent />
                <Typography
                  variant="subtitle"
                  marginTop={{ xs: '4x' }}
                  marginBottom={{ xs: '1x', md: '2x' }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="paragraph1"
                >
                  {item.description}
                </Typography>
              </Box>
            );
          })}
        </StyledContainer>
      </Box>
    </Box>
  );
}

SectionSecurity.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionSecurity);
